export default __webpack_public_path__ + "static/media/1681.c5f20b83.png";